import { render, staticRenderFns } from "./membersDataTable.vue?vue&type=template&id=5234dd30&scoped=true"
import script from "./membersDataTable.vue?vue&type=script&lang=js"
export * from "./membersDataTable.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/styles/introduce-common.scss?vue&type=style&index=0&id=5234dd30&prod&lang=scss&scoped=true&external"
import style1 from "./membersDataTable.vue?vue&type=style&index=1&id=5234dd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234dd30",
  null
  
)

export default component.exports